<template>
 
  <div id="ServiceCodeGRPSpecRate">
    <b-modal id="ServiceCodeGRPSpecRateAddEdit"  size="md" v-model="showEditModal"  no-close-on-esc no-close-on-backdrop hide-header-close
          ok-variant cancel-variant hide-footer
          header-class="PopUpHeader" 
          :body-bg-variant=PopUpVar.bodyBgVariant
          :body-text-variant=PopUpVar.bodyTextVariant
          :footer-bg-variant=PopUpVar.footerBgVariant
          :footer-text-variant=PopUpVar.footerTextVariant> 
        <ServiceCodeGRPSpecRateAddEdit v-if="showEditModal==true" :UserData="UserData" :UserRow="editedRow"  :DataSet="tableData" :mode="mode" :LookUp="lookup" @GRPSpecRateUpdate="UpdateRecord"></ServiceCodeGRPSpecRateAddEdit>
        
        <template slot="modal-header"> 
            <div>
            <small class="modal-title PopUpTitle w-100 text-left">{{mode}} Max Specialist Amount</small>
          </div> 
          <div v-show="mode=='Edit'"><small class="modal-title w-100 text-right"></small></div>
        </template> 
        <div slot="modal-footer" class="w-100"> 
        </div>
      </b-modal> 

      <div class="row" >
        <div class="col-5">
          <label for="VueTables_Adduser" class="VueTables_user small">Max Specialist Amount:</label>
          <div slot="beforeBody"  class="VueTables_Adduser small">
            <!-- <button :disabled="readonly || noSubTypes || maxRows" v-on:click="AddGRPSpecRatePopup" type="button"  class="btn btn-primary btn-smlb">Add Specialist Amount</button> -->
            <button :disabled="maxRows || lookup.length==0 || readonly || maxRows"   v-on:click="AddGRPSpecRatePopup" type="button"  class="btn btn-primary btn-smlb">Add Specialist Amount</button>
          </div>
        </div>
        <div class="col-7">
          <v-client-table  ref="table" class="small" :columns="columns" :data="tableData" :options="options">
          <span class="pointer" v-on:click="DeleteRecordMsgBox('Are you sure you want to delete this Max Specialist Amount?'   ,props)" slot="delete" slot-scope="props" ><i class="far fa-trash-alt"></i></span>
          <span class="pointer" v-on:click="EditGRPSpecRatePopup(props)"  slot="edit" slot-scope="props" ><i class="far fa-edit"></i></span>
          </v-client-table> 
        </div>
    </div>
  </div>

</template>



<script>
import axios from 'axios';
import moment from 'moment'
import { PopUpVariant } from '@/Common/Default/PopUpVariant';
import Card from "@/Common/Card.vue";
import CardBody from "@/Common/CardBody.vue";
import TileNote from "@/Common/TileNote.vue";
import Modal from '../../../Common/ModelPop.vue';
import ServiceCodeGRPSpecRateAddEdit from '@/components/DPEBB/Administrator/ServiceCodeGRPSpecRateAddEdit.vue';
const MaxGrpSpecRates = 8;
export default {
props:{
      Data:'',
      LookUp:'',
      ReadOnly:false,
      codeIndTooth:''
    },
     data: function(){
        return {
            showModal:false,
            isValid:false,
            Access:'',
            AllowAdd:false,
            showEditModal:false,
            PopUpVar:PopUpVariant,
            isValid:'',
            mode:'',
            Button:'',
            readonly:false,
            UserData:'',
            editedRow:'',
            lookup:[],
            test:"afdasdf",
            subtypes:[],
            noSubTypes :false,
            maxRows:false,

        columns: ['delete','edit','desc','amtChargeSpec'],
        tableData: [],
        options: {
          skin:"table-striped table-bordered table-hover",
        texts:{
              count:'',
              first:'First',
              last:'Name',
              filter:"Search Max Specialist Amount:",
              limit:"Records:",
              page:"Page:",
              noResults:"No matching records",
              filterBy:"Filter by {column}",
              loading:'Loading...',
              defaultOption:'Select {column}',
              columns:'Columns'
          }, 
       
          responseAdapter({data}) {
           
              return {
                data: formatData,
                count: data.length
              };
             
            },
         
          perPage:10,
          perPageValues:[10,15,25],
          // dateColumns:['effectivedate','expirydate'],
          // toMomentFormat: 'YYYY-MM-DD',
          //  templates: {
          //    codeSpecType(h, row){

          //     var vm = this;
          //     var params = new URLSearchParams();
          //     params.append('ServiceID',[1,2,3,4,5]);
          //     axios.get('SaskHealthApi/Codes/GetServiceSubtypesCombo?_='+Date.now(), { headers: { 'Authorization': 'Bearer ' + localStorage.access_token },params})
          //         .then(function (response) {
          //         vm.subtypes = response.data.items
          //     })
          //     .catch(function (er) {
          //         console.log(er)
          //     })
          //     .then(function(respone){
          //       // console.log(response);
          //         return vm.subtypes.find(x=>x.type == row.codeSpecType).text;
          //     });
          //     }
          //  },
          headings: {
            desc: 'Specialist Code',
            amtChargeSpec: 'Specialist Amount',
            edit:'',
            delete:''
          },
          pagination: {
            edge: true,
            nav: 'scroll',
            chunk: 5
          },
          sortable: ['codeSpecType','amtChargeSpec'],
           filterable: '', 
          sortIcon: {
                  base : 'fas',
                  is: 'fa-sort',
                  up: 'fa-sort-up',
                  down: 'fa-sort-down'
                  },
            }       
        }
    },
        components: {
          Modal:Modal,
          Card,
          CardBody,
          TileNote,
          ServiceCodeGRPSpecRateAddEdit
        
        },
        created:function(){
          //console.log('at create = ' +this.LookUp);
          this.lookup = this.LookUp;
          this.tableData = this.Data;         
          this.noSubTypes = this.lookup.length <=0;
          // console.log(this.tableData);
          this.readonly = this.ReadOnly;
          // hide admin column
          if (this.readonly || this.noSubTypes) 
            this.columns.splice(this.columns.findIndex(column => column == 'edit'), 1);
          if (this.readonly) 
            this.columns.splice(this.columns.findIndex(column => column == 'delete'), 1);
          this.maxRows = this.tableData.length == MaxGrpSpecRates;
        },

        methods:{
        AddGRPSpecRatePopup(){
          this.editedRow = -1;
          this.mode='Add';
          this.UserData = '';
          this.showEditModal=true;
        },
        EditGRPSpecRatePopup(Rowdata){
          this.editedRow = Rowdata.index -1;
          this.mode='Edit';
          this.UserData = Rowdata.row
          this.showEditModal=true;
        },
         DeleteRecordMsgBox(msg,data) {
        this.boxTwo = ''
        this.$bvModal.msgBoxConfirm(msg, {
          title: 'Please Confirm',
          size: 'md',
          buttonSize: 'md',
          okVariant: 'danger',
          cancelVariant: 'default',
          okTitle: 'YES',
          cancelTitle: 'NO',
          footerClass: 'p-2',
          hideHeaderClose: true,
          centered: true, 
          
        })
          .then(value => {
            this.boxTwo = value
            var vm = this;
            if(value)
            {
              this.tableData.splice((data.index -1),1);
              this.maxRows = this.tableData.length == MaxGrpSpecRates;
            }
          })
          .catch(err => {
              console.log(err);
          })
      },
      UpdateRecord(value) { 
        this.showEditModal = false;
         if(this.editedRow != -1){
          this.tableData[this.editedRow].codeSpecType = value.codeSpecType;
          this.tableData[this.editedRow].amtChargeSpec = value.amtChargeSpec;
          this.tableData[this.editedRow].desc = value.desc
         // console.log(this.tableData[this.editedRow]);
        }
        else{
            //console.log(value);
            this.tableData.push({codeSpecType:value.codeSpecType, desc:value.desc, amtChargeSpec:value.amtChargeSpec});
        }
        this.maxRows = this.tableData.length == MaxGrpSpecRates;
      },
        }

}
</script>

<style>
#ServiceCodeGRPSpecRate  .modal-dialog {
    max-width: 40%;
    margin: 0;
    top: 5%;
    bottom: 0;
    left: 20%;
    right: 20%;
    height: 35vh;
    display: flex;
    /* position: fixed; */
    z-index: 100000;
}
</style>
